import React from "react";
import { Badge } from "reactstrap";

import { currencyFormatter } from "utils/formatter";

/** Terminal amounts are in tiyin; everything shown to a human is in sum. */
export const fromTiyin = (tiyin) => Math.round(Number(tiyin) || 0) / 100;

export const money = (tiyin) =>
  currencyFormatter(`${fromTiyin(tiyin)}`, "UZS") || "0 UZS";

export const moneyUzs = (uzs) =>
  currencyFormatter(`${Math.round(Number(uzs) || 0)}`, "UZS") || "0 UZS";

export const SALE_STATUS_META = {
  pending: { color: "warning", label: "Awaiting result" },
  registered: { color: "success", label: "Registered" },
  failed: { color: "danger", label: "Failed" },
};

export const SaleStatusBadge = ({ status, refundedAmount }) => {
  const meta = SALE_STATUS_META[status] || SALE_STATUS_META.failed;
  return (
    <>
      <Badge color={meta.color} className="text-white">
        {meta.label}
      </Badge>
      {refundedAmount > 0 && (
        <Badge color="dark" className="text-white ml-1">
          Refunded
        </Badge>
      )}
    </>
  );
};

// What the cashier chooses. Two of these are the same thing to the fiscal
// terminal - "Cashless" - but mean different things to us, so they are kept
// apart here and translated by toTerminalTender.
export const PAYMENT_TYPE_OPTIONS = [
  { value: "Cash", label: "Cash" },
  { value: "Card", label: "Card on this terminal" },
  { value: "CardOther", label: "Card on another terminal" },
  { value: "Bank", label: "Bank transfer" },
  { value: "Certificate", label: "Certificate" },
];

// Icon per payment method on the till's method buttons (iconsmind font).
export const METHOD_ICONS = {
  Cash: "iconsminds-money-bag",
  Card: "iconsminds-credit-card",
  CardOther: "iconsminds-credit-card-3",
  Bank: "iconsminds-bank",
  Certificate: "iconsminds-diploma-2",
};

// Cards taken on a bank terminal and fiscalised here as Cashless - Humo, for
// one, which the fiscal terminal cannot read.
export const OTHER_TERMINAL_CARDS = [
  { value: "Humo", label: "Humo" },
  { value: "Uzcard", label: "Uzcard" },
  { value: "Visa", label: "Visa" },
  { value: "Mastercard", label: "Mastercard" },
  { value: "UnionPay", label: "UnionPay" },
];

/** Turns the cashier's choice into the tender the backend expects. */
export const toTerminalTender = (payment) => {
  const base = { amountUzs: payment.amountUzs };
  switch (payment.paymentType) {
    case "CardOther":
      return {
        ...base,
        paymentType: "Cashless",
        cardBrand: payment.cardBrand,
        externalReference: String(payment.externalReference || "").trim(),
      };
    case "Bank":
      return { ...base, paymentType: "Cashless" };
    default:
      return { ...base, paymentType: payment.paymentType };
  }
};

export const SALE_TYPE_OPTIONS = [
  { value: "Sale", label: "Sale — paid in full now" },
  { value: "Credit", label: "Credit — fiscalised now, paid later" },
  { value: "Prepayment", label: "Prepayment — fiscalised once fully paid" },
];
